import { ProductVariantWeightViewModel } from '@/types/api';
import { cn } from '@/utils/cn';
import WeightDisplay from './weight-display';
interface Props {
  weight: ProductVariantWeightViewModel;
  isSelected?: boolean;
  isSalable: boolean;
  handleClick: () => void;
  handleMouseEnter?: () => void;
  handleMouseLeave?: () => void;
  className?: string;
}
const WeightVariant = ({
  weight,
  handleClick,
  isSelected = false,
  isSalable,
  handleMouseEnter,
  handleMouseLeave,
  className
}: Props) => {
  return <button onClick={handleClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className={cn('left-to-right rounded border border-solid border-border-gray-light px-2 py-1.5 text-body-14', {
    'border- text-text-darkGray': isSalable && !isSelected,
    'border-primary-main bg-surface-solid-0 text-text-black': isSelected,
    'bg-surface-solid-100 text-text-mediumGray': !isSalable
  }, className)} data-sentry-component="WeightVariant" data-sentry-source-file="weight-variant.tsx">
            <WeightDisplay value={weight.value || 0} unit={weight.unit || ''} data-sentry-element="WeightDisplay" data-sentry-source-file="weight-variant.tsx" />
        </button>;
};
export default WeightVariant;